import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const VendorManager = () => {
  const { user, logout } = useAuth();
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [formError, setFormError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', password: '', contact_person: '' });

  useEffect(() => { fetchVendors(); }, []);

  const fetchVendors = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/vendors');
      setVendors(Array.isArray(response.data) ? response.data : (response.data.data || []));
    } catch (err) {
      setError('Failed to load vendors.');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setFormError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.email.trim() || !formData.password.trim()) {
      setFormError('Name, email, and password are required');
      return;
    }
    setSubmitting(true);
    try {
      await axios.post('/api/auth/vendors', formData);
      setFormData({ name: '', email: '', password: '', contact_person: '' });
      fetchVendors();
    } catch (err) {
      setFormError(err.response?.data?.error || 'Failed to create vendor.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="vendor-manager">
      <header className="header">
        <div className="header-content">
          <div className="header-left">
            <div className="header-logo">TradeSync</div>
            <nav className="header-nav">
              <Link to="/dashboard">Dashboard</Link>
              <Link to="/vendors" className="active">Vendors</Link>
            </nav>
          </div>
          <div className="header-right">
            <div className="user-info"><span className="user-badge">{user?.role}</span><span>{user?.email}</span></div>
            <button className="logout-btn" onClick={logout}>Logout</button>
          </div>
        </div>
      </header>

      <main className="vendor-manager-content">
        <div className="dashboard-header"><h2>Vendor Management</h2><p>Create and manage vendor accounts.</p></div>
        {error && <div className="error-alert">{error}</div>}
        <div className="vendor-manager-grid">
          <div className="vendor-form-card">
            <div className="vendor-form-header"><h3>➕ Create New Vendor</h3></div>
            <div className="vendor-form-body">
              <form onSubmit={handleSubmit}>
                {formError && <div className="error-message" style={{ marginBottom: '1rem' }}>{formError}</div>}
                <div className="form-row"><label>Company Name *</label><input type="text" name="name" value={formData.name} onChange={handleInputChange} required /></div>
                <div className="form-row"><label>Email *</label><input type="email" name="email" value={formData.email} onChange={handleInputChange} required /></div>
                <div className="form-row"><label>Password *</label><input type="password" name="password" value={formData.password} onChange={handleInputChange} required minLength="8" /></div>
                <div className="form-row"><label>Contact Person</label><input type="text" name="contact_person" value={formData.contact_person} onChange={handleInputChange} /></div>
                <button type="submit" className="submit-btn" disabled={submitting}>{submitting ? 'Creating...' : 'Create Vendor Account'}</button>
              </form>
            </div>
          </div>
          <div className="vendor-list-card">
            <div className="vendor-list-header"><h3>📋 Registered Vendors</h3></div>
            <div className="vendor-list-body">
              {loading ? <div className="loading-spinner">Loading...</div> : vendors.length === 0 ? (
                <div className="empty-state"><div className="empty-state-icon">🏢</div><h3>No vendors yet</h3></div>
              ) : vendors.map(vendor => (
                <div key={vendor.id} className="vendor-item">
                  <div className="vendor-info"><h4>{vendor.name}</h4><p>{vendor.email}</p>{vendor.contact_person && <p style={{ marginTop: '0.25rem', fontSize: '0.75rem' }}>Contact: {vendor.contact_person}</p>}</div>
                  <span className="vendor-badge">{vendor.is_active ? 'Active' : 'Inactive'}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default VendorManager;
